// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"InformationList_contentContainer__1HjEP","sidenavContainer":"InformationList_sidenavContainer__ayT6x"};